import styled from "styled-components";

export const CenterCard = styled.div``;
